import { Component, Input } from '@angular/core';

@Component({
  selector: '[decorator]',
  imports: [],
  templateUrl: './decorator.component.html',
  styleUrl: './decorator.component.scss',
  host: {
    class: 'position-absolute top-0 start-0 z-1 h-100 d-flex',
  },
})
export class DecoratorComponent {
  @Input() lineLeft = {
    firstLineColor: '',
    secondLineColor: '',
  };
}
